import { UseMutationOptions, useMutation } from "@tanstack/react-query";
import { FieldValues } from "react-hook-form";
import axiosAuth from "../../axiosAuth";
import { STATE_LAW_API } from "./apiRoutes";

interface mutateProps {
  data: FieldValues;
  stateLawId: string;
}

const mutateUpdateStateLaw = async ({ data, stateLawId }: mutateProps) => {
  return await axiosAuth.put(`${STATE_LAW_API}/${stateLawId}`, data);
};

const useUpdateStateLawMutation = (
  queryParams?: UseMutationOptions<any, Error, mutateProps, unknown>
) =>
  useMutation({
    mutationFn: mutateUpdateStateLaw,
    ...queryParams,
  });

export default useUpdateStateLawMutation;
